(function () {
  function initStoreSelector() {
    const wrapper = document.getElementById('store-selector');
    if (!wrapper || wrapper.dataset.initialized) return;
    wrapper.dataset.initialized = 'true';

    const trigger = document.getElementById('store-selector-trigger');
    const dropdown = document.getElementById('store-selector-dropdown');
    const label = document.getElementById('store-selector-label');
    const options = wrapper.querySelectorAll('.store-selector__option');

    const COOKIE_NAME = 'selected_store';
    const COOKIE_DAYS = 365;

    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + date.toUTCString() + ';path=/;SameSite=Lax';
    }

    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : null;
    }

    function markSelected(handle) {
      options.forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset.storeHandle === handle);
      });
    }

    function updateCartAttribute(title) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { selected_branch: title } })
      }).catch(function (err) {
        console.error('Store attribute update failed:', err);
      });
    }

    function applySavedStore() {
      let savedHandle = getCookie(COOKIE_NAME);
      if (!savedHandle) {
        try {
          savedHandle = localStorage.getItem(COOKIE_NAME);
        } catch (e) {
          savedHandle = null;
        }
      }
      if (!savedHandle) return;

      const matched = wrapper.querySelector('[data-store-handle="' + savedHandle + '"]');
      if (matched) {
        label.textContent = matched.dataset.storeTitle;
        trigger.classList.add('store-selector__trigger--active');
        markSelected(savedHandle);
      }
    }

    function selectStore(button) {
      const handle = button.dataset.storeHandle;
      const title = button.dataset.storeTitle;

      setCookie(COOKIE_NAME, handle, COOKIE_DAYS);
      try {
        localStorage.setItem(COOKIE_NAME, handle);
      } catch (e) {}

      label.textContent = title;
      trigger.classList.add('store-selector__trigger--active');
      markSelected(handle);
      closeDropdown();

      document.dispatchEvent(new CustomEvent('store:selected', { detail: { handle: handle, title: title } }));
      updateCartAttribute(title);
    }

    function openDropdown() {
      dropdown.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
      dropdown.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      dropdown.hidden ? openDropdown() : closeDropdown();
    });

    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectStore(btn);
      });
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        closeDropdown();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDropdown();
    });

    applySavedStore();
  }

  // Observer ko HAMESHA chalne do — kabhi disconnect na karo,
  // taaki header re-render hone par bhi naya element detect ho
  const observer = new MutationObserver(function () {
    initStoreSelector();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', initStoreSelector);
  initStoreSelector();
})();